import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Grid } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import ModoListagemObservacoes from './components/ModoListagemObservacoes/ModoListagemObservacoes';
import { atualizarFiliado, geetFiliadoPorIdFiliado } from '../../services/FiliadoService';
import ModoVisualizacaoObservacao from './components/ModoVisualizacaoObservacao/ModoVisualizacaoObservacao';
import Slide from '@material-ui/core/Slide';
import ModoInsercaoObservacao from './components/ModoInsercaoObservacao/ModoInsercaoObservacao';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function DialogFiliadoObservacoes(props) {
  const {
    open,
    setOpen,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    setLoading
  } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [modoListagem, setModoListagem] = useState(true);
  const [modoInsercao, setModoInsercao] = useState(false);
  const [modoVisualizacao, setModoVisualizacao] = useState(false);
  const [filiado, setFiliado] = useState(props.filiado);
  const [observacaoSelecionada, setObservacaoSelecionada] = useState();

  useEffect(() => {
    if(open === true) {
      carregarFiliadoCompleto();
    }
  }, [open]);

  async function carregarFiliadoCompleto() {
    try {
      setLoading(true);
      let filiado = await geetFiliadoPorIdFiliado(props.filiado.idFiliado);
      setLoading(false);
      if (filiado.isSuccess) {
        if (filiado.result.length > 0) {
          setFiliado(filiado.result[0])
        } else {
          setTypeSnack('warning');
          setMessageSnack('Não foi possível obter os dados do filiado.');
          setShowMessageSnack(true);
        }
      } else {
        setTypeSnack('error');
        setMessageSnack(filiado.message);
        setShowMessageSnack(true);
      }
    } catch (e) {
      setTypeSnack('error');
      setMessageSnack(e.toString());
      setShowMessageSnack(true);
    }
  }

  function visualizarObservacao(event, index) {
    try {
      event.preventDefault();
      setObservacaoSelecionada(filiado.observacoes[index]);
      setModoListagem(false);
      setModoInsercao(false);
      setModoVisualizacao(true);
    }
    catch (e) {
      setTypeSnack('error');
      setMessageSnack('Ocorreu um erro ao obter informações dessa observação');
      setShowMessageSnack(true);
    }
  }

  function visualizarListagem(event) {
    try {
      event.preventDefault();
      setObservacaoSelecionada(null);
      setModoListagem(true);
      setModoInsercao(false);
      setModoVisualizacao(false);
    }
    catch (e) {
      setTypeSnack('error');
      setMessageSnack('Ocorreu um erro ao obter informações de observações');
      setShowMessageSnack(true);
    }
  }

  function inserirNovaObservacao(event) {
    try {
      event.preventDefault();
      setModoListagem(false);
      setModoInsercao(true);
      setModoVisualizacao(false);
    }
    catch (e) {
      setTypeSnack('error');
      setMessageSnack('Ocorreu um erro ao abrir modo inserção');
      setShowMessageSnack(true);
    }
  }

  function close() {
    setOpen(false);
    setModoVisualizacao(false);
    setModoListagem(true);
    setModoInsercao(false);
  }

  async function salvarNovaObservacao(event, observacao) {
    try {
      setOpen(false);
      setLoading(true);
      let dadosPut = {
        observacoes: [observacao],
        idFiliado: filiado.idFiliado
      };
      let dados = await atualizarFiliado(dadosPut);
      if(dados.isSuccess) {
        await carregarFiliadoCompleto();
        setOpen(true);
        setLoading(false);
        setModoInsercao(false);
        setModoListagem(false);
        setModoListagem(true);
      }
      else {
        setTypeSnack('error');
        setMessageSnack(dados.message);
        setShowMessageSnack(true);
      }
    } catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack('Ocorreu um erro ao salvar nova observação');
      setShowMessageSnack(true);
    }
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      aria-labelledby="form-dialog-title"
      fullWidth
      onClose={close}
      TransitionComponent={Transition}

    >
      <DialogContent>
        <Grid
          container
          spacing={2}
          style={{
            minHeight: 200
          }}
        >
          {
            modoListagem &&
              <Grid
                item
                md={12}
                xs={12}
              >
                <ModoListagemObservacoes
                  filiado={filiado}
                  observacaoSelecionada={observacaoSelecionada}
                  setObservacaoSelecionada={setObservacaoSelecionada}
                  visualizarObservacao={visualizarObservacao}
                />
              </Grid>

          }
          {
            modoVisualizacao &&
            <Grid
              item
              md={12}
              xs={12}
            >
              <ModoVisualizacaoObservacao
                filiado={filiado}
                observacaoSelecionada={observacaoSelecionada}
                setObservacaoSelecionada={setObservacaoSelecionada}
                visualizarListagem={visualizarListagem}
              />
            </Grid>

          }
          {
            modoInsercao &&
            <Grid
              item
              md={12}
              xs={12}
            >
              <ModoInsercaoObservacao
                filiado={filiado}
                salvarNovaObservacao={salvarNovaObservacao}
                visualizarListagem={visualizarListagem}
              />
            </Grid>

          }
          {
            modoListagem &&
            <Grid
              item
              md={12}
              xs={12}
            >
              <Button
                variant={'outlined'}
                margin={'dense'}
                fullWidth
                onClick={e => inserirNovaObservacao(e)}
              >
                NOVA OBSERVACAO
              </Button>
            </Grid>
          }
        </Grid>


      </DialogContent>
    </Dialog>
  );
}

DialogFiliadoObservacoes.propTypes = {
  className: PropTypes.string,
  usuario: PropTypes.object.isRequired,
};

export default DialogFiliadoObservacoes;


